var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deleteTaskShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "deleteTask" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n              " +
                _vm._s(_vm.$t("language.popup.taskListPopup.deleteTask")) +
                "\r\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.deleteTaskShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "delete-body" }, [
            _c("div", { staticClass: "delete-info" }, [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.popup.taskListPopup.deleteSingleTask")
                  )
                )
              ]),
              _vm._v(" "),
              false
                ? _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.popup.taskListPopup.sureDeleteTask")
                      )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "delete-task-button" }, [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.deleteTask(_vm.deleteItem)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.delete")))]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d76fa6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d76fa6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/delete_task_popups.vue
// module id = null
// module chunks = 